import { render, staticRenderFns } from "./FieldsetBox.vue?vue&type=template&id=6f07d345&scoped=true&"
import script from "./FieldsetBox.vue?vue&type=script&lang=js&"
export * from "./FieldsetBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07d345",
  null
  
)

export default component.exports